import React,{useEffect} from "react";
import Layout from "../Components/Layout";
import { Accordion } from "rsuite";
import WOW from 'wowjs';
import 'animate.css';
function Faqs() {
    useEffect(() => {
    new WOW.WOW({
      live: false, // Disable live updates (improves performance)
    }).init();
  }, []);

  return (
    <Layout>
      <section>
        <div className="container">
          <div className="row mb-5">
            <div className="col-xl-10 mt-4 mx-auto text-center">
              <h2 className="text-dark wow animate__animated animate__fadeInUp">
                Haramayn Rooms- Largest Market Place to Search Hotel Rooms in Makkah
                and Madina
              </h2>
              {/* <div className="hstack mt-3 gap-3 flex-wrap justify-content-center">
                <h6 className="bg-mode shadow rounded-2 fw-normal d-inline-block py-2 px-4">
                  <img src={image6} className="h-20px me-2" alt="" />
                  14K+ Global Customers
                </h6>

                <h6 className="bg-mode shadow rounded-2 fw-normal d-inline-block py-2 px-4">
                  <img src={image7} className="h-20px me-2" alt="" />
                  10K+ Happy Customers
                </h6>

                <h6 className="bg-mode shadow rounded-2 fw-normal d-inline-block py-2 px-4">
                  <img src={image8} className="h-20px me-2" alt="" />
                  1M+ Subscribers
                </h6>
              </div> */}
            </div>
          </div>
          <Accordion defaultActiveKey={1} bordered className='mb-4 wow animate__animated animate__fadeInUp'>
            <Accordion.Panel header="What is Haramayn Rooms?" eventKey={1}>
                <p>Haramayn Rooms is a B2B hotel booking platform that helps travel agents search, compare, and book hotels in Makkah, Madinah, and nearby. You get real-time availability, competitive rates, and seamless booking experiences.</p>
            </Accordion.Panel>
            <Accordion.Panel header="How does it benefit travel agents?" eventKey={2}>
                <p>As a travel agent, you can access a wide network of hotels, compare prices efficiently, and confirm bookings instantly — all through one platform. It streamlines your workflow and enhances client satisfaction.</p>
            </Accordion.Panel>
            <Accordion.Panel header="Which destinations are covered?" eventKey={3}>
              <p>Our primary focus is on holy destinations like Makkah and Madinah, but we also feature hotels in other nearby areas to facilitate flexible travel needs.</p>
            </Accordion.Panel>
            <Accordion.Panel header="Can we book different room types and classes?" eventKey={4}>
              <p>Yes — agents can choose from a variety of room types and hotel classes, ranging from budget-friendly to premium accommodations, as per their clients’ preferences and budgets.</p>
            </Accordion.Panel>
            <Accordion.Panel header="How does booking work — is it instant?" eventKey={5}>
              <p>Yes, the platform offers a live availability system that allows instant bookings. Once your client selects a room, it’s confirmed immediately — no back-and-forth, just click and confirm.</p>
            </Accordion.Panel>
            <Accordion.Panel header="Who manages the hotels and booking inventory?" eventKey={6}>
              <p>Hotel management adds rooms and facilities directly into the system. From there, agents can search, compare, and manage bookings for their clients all in one place.</p>
            </Accordion.Panel>
            <Accordion.Panel header="Is there 24/7 support available?" eventKey={7}>
              <p>Yes, as part of the Haramayn Group’s travel technology ecosystem, the platform is backed by round-the-clock support to ensure smooth operations and assistance whenever needed.</p>
            </Accordion.Panel>
            <Accordion.Panel header="How do we get started?" eventKey={8}>
              <p>Simply register as an agent, log in to the platform, and you’ll be able to access hotel listings, availabilities, and initiate bookings right away.</p>
            </Accordion.Panel>
            <Accordion.Panel header="Who do I contact if I have issues with my booking?" eventKey={9}>
              <p>If you have any issues or questions about your booking, please reach out to our customer support team. You can contact us via email, phone, or live chat for assistance.</p>
            </Accordion.Panel>
          </Accordion>
        </div>
      </section>
    </Layout>
  );
}
export default Faqs;
